import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProductionQualityCheck from '../../components/ProductionQualityCheck';
import { Route } from 'react-router-dom';
import { PRODUCTIONQUALITYCHECK } from '../../routes';

const ProductionQualityCheckRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PRODUCTIONQUALITYCHECK}
				render={props => <ProductionQualityCheck {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProductionQualityCheckRoute;
